export const public_ = {
  navigation: {
    logo: "THE OVERHEAR PROJECT",
    home: "Home",
    about: "About",
    helpUs: "Help Us",
    blog: "Blog",
    poetsWritersModods: "Poets, Writers & Moods",
    contact: "Contact"
  },
  hero: {
    title: "OVERHEAR",
    appStore: "Download on the App Store",
    googlePlay: "Get it on Google Play"
  },
  sections: {
    geolocatedAudio: {
      title: "Geolocated Audio",
      subtitle: "Digital maps of geolocated audio for exploring",
      description: "Cities, Festivals, Galleries, Museums and more..."
    },
    services: {
      title: "Services",
      subtitle: "Explore our three key audio storytelling services for the most comprehensive and engaging audio experiences.",
      geolocatedAudio: {
        title: "Geolocated Audio",
        description: "Digital maps of audio content connecting location-specific storytelling."
      },
      storytelling: {
        title: "Storytelling & Presenting Audio", 
        description: "Expert curation, direction and management of audio projects."
      },
      socialAudio: {
        title: "Social Audio",
        description: "Real-world audio experiences designed to create connection."
      }
    },
    about: {
      title: "OVERHEAR",
      subtitle: "creates engagement by uncovering the symbiotic relationship between creative audio & location",
      description1: "We invite you to attune your perceptions to the undercurrents of creative audio sitting just below the surface of creative spaces.",
      description2: "Move into the stream & see what eddies and whirlpools form in response to simply being where you stand.",
      description3: "Tap into the potential of the spaces you steward and work with artists and producers to explore the relationships we can foster.",
      contact: "Drop an email to hello@theoverhear.app and love to have a chat."
    },
    team: {
      title: "Our Team",
      subtitle: "Creative facilitators passionate about audio storytelling and community engagement"
    }
  },
  testimonials: {
    first: {
      type: "quote",
      text: "The whole team at OVERHEAR made the experience of working with them a seamless and enjoyable experience, allowing me to concentrate fully on the writing and recording of my piece.",
      author: "Rick Sanders - Poet"
    },
    second: {
      type: "star",
      text: "really fun way to hear new poetry while being guided to find some cool and interesting places in the city",
      author: "Naomi R",
      rating: 5
    },
    third: {
      type: "star", 
      text: "added so many rich layers to the experience of discovering a place",
      author: "Landres",
      rating: 5
    },
    fourth: {
      type: "quote",
      text: "...a terrific experience, both for our Birmingham Literature Festival audiences & the many writers we have been able to involve. New work has been made & new audiences discovered, Tom & his team have been both creative & entrepreneurial in their approach.",
      author: "Jonathan Davidson -",
      authorTitle: "Writing West Midlands"
    },
    fifth: {
      type: "picture",
      text: "take a walk around the city with the App, and collect all the gorgeous statue poems dotted around!",
      author: "scarlet.ward",
      image: "/assets/overhear-assets/images/testimonials/user-photo.jpg"
    }
  },
  phoneMockup: {
    map: {
      appTitle: "Overhear",
      locationLabel: "Dublin City Centre",
      nearbyAudio: "Nearby Audio Stories",
      trinityStories: "Trinity College Stories",
      templeBarMemories: "Temple Bar Memories"
    },
    library: {
      title: "Library",
      recentlyPlayed: "Recently Played",
      collections: "Collections",
      healthcareStories: {
        title: "Healthcare Stories",
        subtitle: "MMUH Voices"
      },
      culturalVoices: {
        title: "Cultural Voices",
        subtitle: "Gallery Stories"
      },
      communityStories: {
        title: "Community Stories",
        count: "12 audio pieces"
      },
      workshopHighlights: {
        title: "Workshop Highlights",
        count: "8 audio pieces"
      },
      favorites: "Favorites",
      downloads: "Downloads"
    }
  },
  footer: {
    sections: {
      about: {
        title: "About",
        links: {
          ourStory: "Our Story",
          mission: "Mission",
          team: "Team"
        }
      },
      services: {
        title: "Services", 
        links: {
          geolocatedAudio: "Geolocated Audio",
          workshops: "Workshops",
          consulting: "Consulting"
        }
      },
      resources: {
        title: "Resources",
        links: {
          blog: "Blog",
          helpUs: "Help Us",
          documentation: "Documentation"
        }
      },
      connect: {
        title: "Connect",
        links: {
          contact: "Contact",
          poetsWritersModods: "Poets, Writers & Moods",
          community: "Community"
        }
      }
    },
    copyright: "© {{year}} The Overhear Project. All rights reserved.",
    privacy: "Privacy Policy",
    terms: "Terms of Use"
  }
}
